const networkErrorPatterns = [
  /Failed to fetch/i,
  /Load failed/i,
  /NetworkError when attempting to fetch resource/i,
];

export { networkErrorPatterns };
